import { Field, ErrorMessage } from "formik";
import { TextField } from "@mui/material";

const MuiInput = ({ name, label, placeholder, requiredField, ...rest }) => (
  <div>
    <Field
      as={TextField}
      name={name}
      label={label}
      placeholder={placeholder}
      required={requiredField}
      fullWidth
      size="small"
      variant="outlined"
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: "8px",
          "&:hover fieldset": { borderColor: "#15b86d" },
          "&.Mui-focused fieldset": { borderColor: "#15b86d" },
        },
        "& .MuiInputLabel-root.Mui-focused": { color: "#15b86d" },
      }}
      {...rest}
    />
    <ErrorMessage
      name={name}
      component="div"
      style={{ color: "#ef4444", fontSize: "0.75rem", marginTop: "4px" }}
    />
  </div>
);

export default MuiInput;
